<template>
    <div class="mt-n16">
        <v-main class="d-flex d-md-none">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="id" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 진행 예정</span> <span v-if="estimates.total > 0" class="headline">({{ estimates.total }})</span></h2>
                </v-col>
                <v-col cols="6">
<!--                    <AddEstimateDialog style="float:right"></AddEstimateDialog>-->
                    <v-btn icon outlined class="mr-3 mt-n1 d-none d-md-flex" style="float:right" @click="getEstimates">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색하세요 :)"
                            outlined
                            dense
                            clearable
                            class="mr-3 mt-n1"
                            style="float:right;"
                            v-model="estimateSearchText"
                            @keydown.enter="getEstimates"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-simple-table class="mx-0 mt-5">
                <template v-slot:default>
                    <thead>
                    <tr>
<!--                        <th class="pl-1 text-left" query-key="name" @click="getOrderedData">거래처</th>-->
<!--                        <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">작성일</th>-->
                        <th class="pl-0 text-center" query-key="dueDate" @click="getOrderedData" style="min-width:50px">납품일</th>
<!--                        <th class="pl-0 text-left" query-key="category" @click="getOrderedData">품목</th>-->
                        <th class="pl-0 text-center" query-key="title" @click="getOrderedData">작업명</th>
                        <th class="pl-0 text-center" query-key="estimateStatus" @click="getOrderedData">진행</th>
                        <th class="pl-0 text-center" query-key="paymentStatus" @click="getOrderedData">결제</th>
<!--                        <th class="pl-0 text-left">진행</th>-->
<!--                        <th class="text-right">삭제</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="estimate in estimates.data" :key="estimate.orderId" dense>
<!--                        <td v-if="estimate.clientName" class="pl-1 caption">{{ estimate.clientName }}</td>-->
<!--                        <td v-else><strong style="color: deeppink" class="'caption">[ 미 입 력 ]</strong></td>-->
<!--                        <td class="caption font-weight-medium">{{ estimate.estimateDate }}</td>-->
                        <td class="caption font-weight-medium">{{ estimate.dueDate.substr(3, 7) }}</td>
<!--                        <td class="caption">{{ estimate.category }}</td>-->
                        <td>
                            <ToOrderDialog v-if="mobileFlag" v-bind:type="'estimate'" v-bind:position="'edit'" :order-id="estimate.orderId" :mode="'string'" :display-string="estimate.title" ref="toOrderButton"></ToOrderDialog>
                        </td>
                        <td class="text-center">
                            <EstimateStatusButton v-if="mobileFlag" :order-id="estimate.orderId" :estimate-status="estimate.estimateStatus" :disable="true"></EstimateStatusButton>
                        </td>
                        <td class="text-center">
                            <PaymentStatusButton v-if="mobileFlag" :order-id="estimate.orderId" :payment-status="estimate.paymentStatus" :disable="true"></PaymentStatusButton>
                        </td>
<!--                        <td>-->
<!--                            <ToOrderDialog v-bind:type="'estimate'" v-bind:order-id="estimate.orderId" v-bind:mode="'button'" ref="toOrderButton"></ToOrderDialog>-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <DeleteOrderButton :order-id="estimate.orderId"></DeleteOrderButton>-->
<!--                        </td>-->
                    </tr>

                    <tr v-if="estimates.length == 0">
                        <td colspan="5" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>

        <v-main class="d-none d-md-block">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="id" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 진행 예정 내역 조회</span> <span v-if="estimates.total > 0" class="headline">({{ estimates.total }})</span> <span class="headline caption">정렬:{{ orderConditionNow }}</span></h2>
                </v-col>
                <v-col cols="6">
                    <AddEstimateDialog style="float:right"></AddEstimateDialog>
                    <v-btn icon outlined class="mr-3 mt-n1" style="float:right" @click="getEstimates">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색어를 입력하세요"
                            outlined
                            dense
                            clearable
                            class="mr-3 mt-n1"
                            style="float:right;"
                            v-model="estimateSearchText"
                            @keydown.enter="getEstimates"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="pl-1 text-left" query-key="name" @click="getOrderedData">거래처</th>
                        <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">작성일</th>
                        <th class="pl-0 text-left" query-key="dueDate" @click="getOrderedData">납품예정일</th>
                        <th class="pl-0 text-left" query-key="category" @click="getOrderedData">품목</th>
                        <th class="pl-0 text-left" query-key="title" @click="getOrderedData">작업명</th>
                        <th class="pl-0 text-left" query-key="estimateStatus" @click="getOrderedData">진행상태</th>
                        <th class="pl-0 text-left" query-key="paymentStatus" @click="getOrderedData">결제상태</th>
                        <th class="pl-0 text-left">진행</th>
                        <th class="text-right">삭제</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="estimate in estimates.data" :key="estimate.orderId" dense>
                        <td v-if="estimate.clientName" class="pl-1 caption">{{ estimate.clientName }}</td>
                        <td v-else><strong style="color: deeppink" class="'caption">[ 미 입 력 ]</strong></td>
                        <td class="caption font-weight-medium">{{ estimate.estimateDate }}</td>
                        <td class="caption font-weight-medium">{{ estimate.dueDate }}</td>
                        <td class="caption">{{ estimate.category }}</td>
                        <td>
                            <ToOrderDialog v-if="pcFlag" v-bind:type="'estimate'" v-bind:position="'edit'" :order-id="estimate.orderId" :mode="'string'" :display-string="estimate.title" ref="toOrderButton"></ToOrderDialog>
                        </td>
                        <td>
                            <EstimateStatusButton v-if="pcFlag" :order-id="estimate.orderId" :estimate-status="estimate.estimateStatus"></EstimateStatusButton>
                        </td>
                        <td>
                            <PaymentStatusButton v-if="pcFlag" :order-id="estimate.orderId" :payment-status="estimate.paymentStatus"></PaymentStatusButton>
                        </td>
                        <td>
                            <ToOrderDialog v-if="pcFlag" v-bind:type="'estimate'" v-bind:order-id="estimate.orderId" v-bind:mode="'button'" ref="toOrderButton"></ToOrderDialog>
                        </td>
                        <td>
                            <DeleteOrderButton v-if="pcFlag" :order-id="estimate.orderId"></DeleteOrderButton>
                        </td>
                    </tr>

                    <tr v-if="estimates.length == 0">
                        <td colspan="9" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import AddEstimateDialog from '@/components/order/AddEstimateDialog'
import ToOrderDialog from "@/components/order/ToOrderDialog";
import EstimateStatusButton from "@/components/order/button/EstimateStatusButton";
import PaymentStatusButton from "@/components/order/button/PaymentStatusButton";
import DeleteOrderButton from "@/components/order/button/DeleteOrderButton";

export default {
    name: 'EstimateRows',
    components: {
        AddEstimateDialog,
        ToOrderDialog,
        EstimateStatusButton,
        PaymentStatusButton,
        DeleteOrderButton
    },
    data () {
        return {
            orderConditionNow: "",
            estimateSearchText: this.searchText,
            estimates: [],
            totalPages: 1,
            page: 1,
            mobileFlag: false,
            pcFlag: false
        }
    },
    watch: {
        estimateSearchText: async function(newText) {
            const queryOptions = await this.$store.getters.getEstimateQueryOptions
            queryOptions.queryText = newText
            await this.$store.dispatch('setEstimateQueryOptions', queryOptions)

            if(newText == ''){
                await this.getEstimates()
            }
        },
        page: async function(newPage, oldPage) {

            if(newPage != oldPage){

                const queryOptions = await this.$store.getters.getEstimateQueryOptions
                queryOptions.page = newPage
                await this.$store.dispatch('setEstimateQueryOptions', queryOptions)
                await this.getEstimates()

            }

        }
    },
    methods: {
        async getEstimates() {
            await this.$store.dispatch('getEstimates')
            this.estimates = await this.$store.getters.getEstimates
            this.totalPages = this.estimates.lastPage
            if(this.page > this.totalPages){
                this.page = 1
            }
        },
        async getOrderedData(e) {

            const key = e.currentTarget.getAttribute('query-key')
            const queryOptions = await this.$store.getters.getEstimateQueryOptions

            queryOptions.prevKey = key

            if(queryOptions.queryKey != key){
                queryOptions.queryKey = key
                queryOptions.queryOrder = 'desc'
            }else if(queryOptions.queryKey == key){
                if(queryOptions.queryOrder == 'desc'){
                    queryOptions.queryOrder = 'asc'
                }else{
                    queryOptions.queryOrder = 'desc'
                }
            }

            this.getOrderConditionNow(key, queryOptions.queryOrder)

            await this.$store.dispatch('setEstimateQueryOptions', queryOptions)
            await this.getEstimates()

        },
        getOrderConditionNow(key, order) {

            //정렬 기준 표기
            if(key == 'id') {
                this.orderConditionNow = "입력시간"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'name') {
                this.orderConditionNow = "거래처"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'estimateDate') {
                this.orderConditionNow = "작성일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'dueDate') {
                this.orderConditionNow = "납품예정일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'category') {
                this.orderConditionNow = "품목"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'title') {
                this.orderConditionNow = "작업명"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'estimateStatus') {
                this.orderConditionNow = "진행상태"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'paymentStatus') {
                this.orderConditionNow = "결제상태"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }

        }
    },
    created: async function() {
        await this.getEstimates()
        setInterval(this.getEstimates, this.$store.getters.getCommonRefreshInterval)

        const queryOptions = await this.$store.getters.getEstimateQueryOptions
        this.page = queryOptions.page
        if (!this.estimateSearchText){
            queryOptions.queryText = ''
            await this.$store.dispatch('setEstimateQueryOptions', queryOptions)
        }

        this.getOrderConditionNow(queryOptions.queryKey, queryOptions.queryOrder)

        switch(this.$vuetify.breakpoint.name) {
            case 'xl':
            case 'lg':
            case 'md':
                this.mobileFlag = false
                this.pcFlag = true
                break
            case 'sm':
            case 'xs':
                this.mobileFlag = true
                this.pcFlag = false
                break
        }
    }
}
</script>

<style scoped>
    .no-data { text-align: center; background-color: aliceblue; }
    /*table, tr, td { padding: 0em }*/
    tr, td {
        padding: 2px !important;
    }
</style>